module.exports = __webpack_public_path__ + "assets/images/41a40fe94998538d241fa9be84a147aa.png";